import React, {useCallback, useEffect, useState} from "react";
import {useQuery} from "react-apollo";
import {Stack} from "@unibuddy/patron";

import {contentListPageQuery} from "../data/contentListPageQuery";
import {BLOG_POSTS_LIMIT_WIDGET} from "../constants";
import {useUniversity} from "../../UniversityProvider/UniversityProvider";
import {FilterContainer} from "../containers/FilterContainer";
import {ContentCardListContainer} from "../containers/ContentCardListContainer";

export type CurrentFiltersType = {
    title?: string;
    topics?: string;
    degrees?: string;
    sort?: string;
};

export function ContentListPage() {
    const {slug} = useUniversity();
    const [searchValue, setSearchValue] = useState<string>("");
    const [currentFilters, setCurrentFilters] = useState<CurrentFiltersType>({});
    const {data, loading, error, fetchMore} = useQuery(contentListPageQuery, {
        variables: {
            universitySlug: slug,
            topics: currentFilters?.topics ?? [],
            degrees: currentFilters?.degrees ?? [],
            title: currentFilters?.title ?? "",
            offset: 0,
            limit: BLOG_POSTS_LIMIT_WIDGET,
            order: currentFilters?.sort ?? "-modified",
        },
    });

    const onSearchOrFilter = useCallback(
        (filterInput: string, filterName: string) => {
            setCurrentFilters((prevFilters) => {
                const filters = {...prevFilters};

                if (filterInput) {
                    filters[filterName] = filterInput;
                } else {
                    delete filters[filterName];
                }
                return filters;
            });
        },
        // TODO: Fire analytics events
        [],
    );

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            onSearchOrFilter(searchValue, "title");
        }, 600);

        return () => clearTimeout(delayDebounce);
    }, [onSearchOrFilter, searchValue]);

    return (
        <Stack space="medium">
            <FilterContainer
                data={data}
                loading={loading}
                currentFilters={currentFilters}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                onSearchOrFilter={onSearchOrFilter}
            />
            <ContentCardListContainer
                data={data}
                loading={loading}
                error={error}
                fetchMore={fetchMore}
            />
        </Stack>
    );
}
